import { LoanProposalStatus_Enum } from "src/types/enums";
import { AvailableProposal } from "src/types/loan-application/index";

export default function useMapProposals(props: AvailableProposal[]) {
  if (!props || !Array.isArray(props)) {
    return [];
  }

  props.forEach(p => {
    //@ts-ignore
    if(p.loanProposalStatus && !isNaN(Number(p.loanProposalStatus))) {
      //@ts-ignore
      p.loanProposalStatus = LoanProposalStatus_Enum[p.loanProposalStatus];
    }
    
    p.financeCompanyId = p.lenderId;
    p.financeCompany = p.lenderName;
    p.amountToFinance = p.amountToFinance ?? 0;
    p.rank = null;
    p.hpRank = null;
  })

  return props;
}
